import _asyncToGenerator from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
import './SurpriseMeForm.css';
import React, { useEffect, useRef, useState } from 'react';
import { canUseDOM, replaceUrlPluses } from '../../utils';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { ReactComponent as IconClose } from '../../resources/icons/close.svg';
import { ReactComponent as IconMailBox } from '../../resources/icons/mailBox.svg';
import { get } from '../../utils/getPropertyByPath';
import { isNil, isNotNil } from '../../utils/IsNil';
import { useLocation } from 'react-router-dom';
import { convertToAnalyticObject } from '../../utils/analytics';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { splitter } from '../Listing';
import { qsToObject } from '../../utils/querystring';
import { checkJssError } from '../../utils/checkJssError';
var SurpriseMeFormComponent = function SurpriseMeFormComponent(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isVdsite = _useState2[0],
    setIsVdsite = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    openForm = _useState4[0],
    setOpenForm = _useState4[1];
  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    emailInputValue = _useState6[0],
    setEmailInputValue = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    checkboxValue = _useState8[0],
    setCheckboxValue = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    emailSentSuccessful = _useState0[0],
    setEmailSentSuccessful = _useState0[1];
  var timerOpenFormId = useRef(null);
  var location = useLocation();
  var language = get(sitecoreContext, 'language') || 'en';
  var title = get(fields, "data.listingConfiguration.title.jss.value");
  var subtitle = get(fields, "data.listingConfiguration.subtitle.jss.value");
  var subscriptionText = get(fields, "data.listingConfiguration.subscriptionText.jss.value");
  var policyText = get(fields, "data.listingConfiguration.policyText.jss.value");
  var buttonText = get(fields, "data.listingConfiguration.buttonText.jss.value");
  var successMessageTitle = get(fields, "data.listingConfiguration.successMessageTitle.jss.value");
  var successMessageText = get(fields, "data.listingConfiguration.successMessageText.jss.value");
  var aPIUrl = get(fields, "data.apiConfigurations.aPIUrl.value");
  useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
    timerOpenFormId.current = setTimeout(function () {
      setOpenForm(true);
      analyticsPopupLoadedHandler();
    }, 5000);
  }, []);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  if (isNil(fields) || isNil(fields.data) || isNil(fields.data.apiConfigurations) || isNil(fields.data.listingConfiguration) || isNil(fields.data.listingConfiguration.travelerTypes) || isNil(fields.data.listingConfiguration.activityInterests) || isNil(fields.data.listingConfiguration.tripTypes) || !fields.data.listingConfiguration.travelerTypes.targetItem || !fields.data.listingConfiguration.activityInterests.targetItem || !fields.data.listingConfiguration.tripTypes.targetItem) {
    console.info('SurpriseMeForm component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [SurpriseMeForm component is empty: please provide data source]");
    }
    return null;
  }
  var travelerTypes = get(fields, "data.listingConfiguration.travelerTypes.targetItem");
  var activityInterests = get(fields, "data.listingConfiguration.activityInterests.targetItem");
  var tripTypes = get(fields, "data.listingConfiguration.tripTypes.targetItem");
  var filtersTravelerTypes = travelerTypes.tagsToDisplay.values.map(function (_ref2) {
    var title = _ref2.title;
    return title.value;
  });
  var filtersActivityInterests = activityInterests.tagsToDisplay.values.map(function (_ref3) {
    var title = _ref3.title;
    return title.value;
  });
  var filtersTripTypes = tripTypes.tagsToDisplay.values.map(function (_ref4) {
    var title = _ref4.title;
    return title.value;
  });
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var getFilterTypes = function getFilterTypes() {
    var types = [travelerTypes, activityInterests, tripTypes];
    var set = new Set();
    types.forEach(function (type) {
      return set.add(type.fieldNameItem.item.fieldName.value);
    });
    return Array.from(set);
  };
  var createQueryParams = function createQueryParams() {
    var queryParams = canUseDOM ? qsToObject(location.search) : {};
    if (Object.keys(queryParams).length !== 0) {
      for (var key in queryParams) {
        var newKeys = key.split('+').join(' ');
        queryParams[newKeys] = queryParams[key].split(splitter).join(', ');
        queryParams[newKeys] = replaceUrlPluses(queryParams[newKeys]) || queryParams[newKeys];
        if (key !== newKeys) {
          delete queryParams[key];
        }
      }
    }
    return queryParams;
  };
  var getFormDataFromQueryString = function getFormDataFromQueryString() {
    var queryParams = createQueryParams();
    var travellerTypeArray = [];
    var leasureInterestArray = [];
    var packageTypeArray = [];
    var filterTypes = getFilterTypes();
    for (var _i = 0, _Object$entries = Object.entries(queryParams); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];
      if (filterTypes.includes(key)) {
        value.split(", ").forEach(function (el) {
          var trimEl = el.trim();
          if (filtersTravelerTypes.includes(trimEl)) {
            travellerTypeArray.push(trimEl);
          }
          if (filtersActivityInterests.includes(trimEl)) {
            leasureInterestArray.push(trimEl);
          }
          if (filtersTripTypes.includes(trimEl)) {
            packageTypeArray.push(trimEl);
          }
        });
      }
    }
    return {
      travellerTypeArray: travellerTypeArray,
      leasureInterestArray: leasureInterestArray,
      packageTypeArray: packageTypeArray
    };
  };
  var analyticsIconClickHandler = function analyticsIconClickHandler() {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['EmailIconClickAnalytics'], params));
  };
  var analyticsEmailSubmitClickHandler = function analyticsEmailSubmitClickHandler() {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['EmailSubmitClickAnalytics'], params), buttonText);
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['EmailSuccessAnalytics'], params));
  };
  var analyticsCloseBeforeIconClickHandler = function analyticsCloseBeforeIconClickHandler() {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['closeBeforeAnalytics'], params));
  };
  var analyticsCloseAfterIconClickHandler = function analyticsCloseAfterIconClickHandler() {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['closeAfterAnalytics'], params));
  };
  var analyticsGrayCloseClickHandler = function analyticsGrayCloseClickHandler() {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['closeGreyAnalytics'], params));
  };
  var analyticsPopupLoadedHandler = function analyticsPopupLoadedHandler() {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['popupLoadedAnalytics'], params));
  };
  var sendEmail = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
      var _getFormDataFromQuery, travellerTypeArray, leasureInterestArray, packageTypeArray, requestParams;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            e.preventDefault();
            _getFormDataFromQuery = getFormDataFromQueryString(), travellerTypeArray = _getFormDataFromQuery.travellerTypeArray, leasureInterestArray = _getFormDataFromQuery.leasureInterestArray, packageTypeArray = _getFormDataFromQuery.packageTypeArray;
            requestParams = new URLSearchParams({
              json: JSON.stringify({
                Subscriberkey: emailInputValue,
                Traveller_Type: travellerTypeArray.length ? travellerTypeArray.join(",") : null,
                Leasure_Interest: leasureInterestArray.length ? leasureInterestArray.join(",") : null,
                Package_Type: packageTypeArray.length ? packageTypeArray.join(",") : null,
                Language: language,
                Hidden_City: "Dubai",
                Hidden_Country: "AE",
                Email_Address: emailInputValue,
                url: canUseDOM ? window.location.href : "",
                Email_Consent: "true"
              })
            }).toString();
            fetch(aPIUrl, {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded"
              },
              method: "POST",
              body: requestParams
            }).then(function (res) {
              if (res.status === 200) {
                setEmailSentSuccessful(true);
                analyticsEmailSubmitClickHandler();
              }
            }).catch(function (err) {
              console.log("err", err);
              throw new Error(err);
            });
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function sendEmail(_x) {
      return _ref5.apply(this, arguments);
    };
  }();
  var openFormHandler = function openFormHandler() {
    setOpenForm(true);
  };
  var closeForm = function closeForm() {
    setOpenForm(false);
  };
  var closeFormWithOutsideClick = function closeFormWithOutsideClick() {
    closeForm();
    analyticsGrayCloseClickHandler();
  };
  var closeFormWithAnalytics = function closeFormWithAnalytics() {
    closeForm();
    analyticsCloseBeforeIconClickHandler();
  };
  var closeFormAndRemoveBlueLine = function closeFormAndRemoveBlueLine() {
    closeForm();
    if (canUseDOM) {
      var element = document.getElementById("successBlueLine");
      if (isNotNil(element)) {
        element.classList.remove("blueLine");
      }
    }
    analyticsCloseAfterIconClickHandler();
  };
  var isButtonEnabled = function isButtonEnabled() {
    return Boolean(emailInputValue.trim().length) && checkboxValue;
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "surpriseMeFormWrapper ".concat(openForm ? "visibleForm" : "hiddenForm")
  }, !emailSentSuccessful ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "formWithLine"
  }, /*#__PURE__*/React.createElement("div", {
    className: "surpriseMeForm"
  }, /*#__PURE__*/React.createElement("p", {
    className: "title"
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "subtitle"
  }, subtitle), /*#__PURE__*/React.createElement("form", {
    onSubmit: sendEmail
  }, /*#__PURE__*/React.createElement("input", {
    type: "email",
    className: "emailInput",
    placeholder: "Email Address *",
    value: emailInputValue,
    onChange: function onChange(value) {
      setEmailInputValue(value.target.value);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "subscription"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    id: "subscription",
    className: "subscriptionCheckbox",
    checked: checkboxValue,
    onChange: function onChange(value) {
      setCheckboxValue(value.target.checked);
    }
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "subscription"
  }, subscriptionText)), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "btn btn-primary sendEmailButton ".concat(isButtonEnabled() ? "" : "disabled"),
    disabled: !isButtonEnabled()
  }, buttonText)), /*#__PURE__*/React.createElement("p", {
    className: "policy",
    dangerouslySetInnerHTML: {
      __html: policyText
    }
  }), /*#__PURE__*/React.createElement("button", {
    className: "closeBtn",
    onClick: closeFormWithAnalytics
  }, /*#__PURE__*/React.createElement(IconClose, {
    className: "iconClose"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "blueLine"
  })), /*#__PURE__*/React.createElement("div", {
    className: "notification ".concat(openForm ? "hiddeNotification" : "visibleNotification"),
    onClick: function onClick() {
      clearTimeout(timerOpenFormId.current);
      openFormHandler();
      analyticsIconClickHandler();
    }
  }, /*#__PURE__*/React.createElement(IconMailBox, {
    className: "iconNotification"
  }), /*#__PURE__*/React.createElement("div", {
    className: "notificationCircle"
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "formWithLine"
  }, /*#__PURE__*/React.createElement("div", {
    className: "surpriseMeForm"
  }, /*#__PURE__*/React.createElement("p", {
    className: "successMessageTitle"
  }, successMessageTitle), /*#__PURE__*/React.createElement("p", null, successMessageText), /*#__PURE__*/React.createElement("button", {
    className: "closeBtn",
    onClick: closeFormAndRemoveBlueLine
  }, /*#__PURE__*/React.createElement(IconClose, {
    className: "iconClose"
  }))), /*#__PURE__*/React.createElement("div", {
    id: "successBlueLine",
    className: "blueLine"
  }))), /*#__PURE__*/React.createElement("div", {
    onClick: closeFormWithOutsideClick,
    className: "".concat(openForm ? "surpriseMeFormWrapperBlur" : "surpriseMeFormWrapperNoBlur")
  }));
};
var SurpriseMeForm = function SurpriseMeForm(props) {
  return checkJssError(props, SurpriseMeFormComponent, props.fields.data.listingConfiguration);
};
var StyledWrapper = function StyledWrapper(_ref6) {
  var children = _ref6.children,
    rtl = _ref6.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "cssa1ql";
var rtlStyles = "ranue4e";
var ltrStyles = "lqniqbv";
export default SurpriseMeForm;